export const setRefreshState = (state, data) => {
  state.refreshState = data;  // 这里的CodeValue 需与index中的名字保持一致
};
